import React from 'react';
import { Chip } from '@mui/material';
import type { CampaignStatus } from '../types';

const COLOR: Record<CampaignStatus, 'default' | 'success' | 'warning'> = {
  DRAFT: 'default',
  ACTIVE: 'success',
  PAUSED: 'warning',
};

export const CampaignStatusChip: React.FC<{ status: CampaignStatus; ended?: boolean }> = ({
  status,
  ended,
}) => (
  <span className="inline-flex items-center gap-1">
    <Chip size="small" label={status} color={COLOR[status]} />
    {ended && <Chip size="small" label="ENDED" variant="outlined" />}
  </span>
);
